import useMyCampaignsByType from './useMyCampaignsByType';
import useCampaignInfo from './useCampaignInfo';

const useMyCampaigns = (chainId: number | undefined) => {
  const {
    campaigns: tokenCampaigns,
    //error: campaignError,
    loading: tokenCampaignLoading,
  } = useMyCampaignsByType('TOKEN', chainId);
  // console.log('tokenCampaigns', tokenCampaigns);
  const {
    campaigns: nftCampaigns,
    //error: campaignError,
    loading: nftCampaignLoading,
  } = useMyCampaignsByType('NFT', chainId);
  // const campaigns = [...nftCampaigns, ...tokenCampaigns];
  const { campaignInfo: tokenCampaignInfo, loading: tokenInfoLoading } =
    useCampaignInfo('TOKEN', tokenCampaigns, chainId);
  const { campaignInfo: nftCampaignInfo, loading: nftInfoLoading } =
    useCampaignInfo('NFT', nftCampaigns, chainId);
  const loading =
    nftCampaignLoading ||
    tokenCampaignLoading ||
    tokenInfoLoading ||
    nftInfoLoading;
  const campaigns = [...nftCampaignInfo, ...tokenCampaignInfo];

  return { campaigns, loading };
};

export default useMyCampaigns;
